package fr.frux.shared.dto

import kotlinx.serialization.Serializable
import kotlin.time.Instant

@Serializable
data class UserDto(
    val id: Long? = null,
    val email: String,
    val username: String,
    @Serializable(with = InstantEpochMillisSerializer::class)
    val createdAt: Instant? = null,
)

/**
 * Profil public d'un contributeur (#227) : jamais d'email ni d'autre donnée de compte — ce
 * contrat est servi sans authentification.
 */
@Serializable
data class UserProfileDto(
    val id: Long,
    val username: String,
    val treesCount: Int,
    val harvestsCount: Int,
    @Serializable(with = InstantEpochMillisSerializer::class)
    val createdAt: Instant,
    /** Le lecteur authentifié masque ce compte (#515, ADR 0029). Toujours faux pour un anonyme. */
    val blockedByMe: Boolean = false,
)
